import { UnClickIcon } from '@carboncopyco/icons';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { ModificationItem } from './ModificationItem';
import { lockLabel } from './utils';

export const LockModificationItem = ({ id }: { id: string }) => {
  const flags = useFlags();
  return (
    <ModificationItem>
      <ModificationItem.Content>
        <ModificationItem.Icon>
          <UnClickIcon size={18} />
        </ModificationItem.Icon>
        <ModificationItem.Text
          label={lockLabel}
          tooltipLabel={
            flags.editorSpotManagerDebugMode
              ? `${lockLabel} (${id})`
              : lockLabel
          }
        />
      </ModificationItem.Content>
    </ModificationItem>
  );
};
